/* Main Menu */
var $ = jQuery.noConflict();

$(function(){
    $(document).ready(function() {

        var tabSliderThis
        $(window).scroll();

        //////////////////////////////////////////////////////////////////////////////////////////////////////
        // START - mobile nav toggle - commented out as it was moved to footer.php so it worked with WP Rocket
		// $('.navbar-toggler').on('click', function() {
		// 	$(this).toggleClass('is-active');
		// 	$('.wrapper-navbar').toggleClass('is-active');
		// 	$('body').toggleClass('nav-is-active');
		// 	// toggle aria expanded value
		// 	$(this).attr('aria-expanded', function(i, attr) {
		// 		return attr == 'true' ? 'false' : 'true'
		// 	});
		// });
        // END - mobile nav toggle
        ///////////////////////////////////////////////

        ////////////////////////////////////////////////
        // START - hide nav on scroll down and show on scroll up
        // COMMENTED OUT AS EARCU NEEDED IT IN VANILLA JS SEE BOTTOM OF FILE
        // $(function(){
        //     var lastScrollTop = 0, delta = 5;
        //     $(window).scroll(function(){
        //         var nowScrollTop = $(this).scrollTop();
        //         if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
        //             if (nowScrollTop > lastScrollTop){
        //                 $('.header').addClass('header-hide');
        //                 $('.header').removeClass('header-show');
        //                 $('html,body').addClass('header-hide');
        //                 $('html,body').removeClass('header-show');
        //             } else {
        //                 $('.header').removeClass('header-hide');
        //                 $('.header').addClass('header-show');
        //                 $('html,body').removeClass('header-hide');
        //                 $('html,body').addClass('header-show');
        //            }
        //         lastScrollTop = nowScrollTop;
        //         }
        //     });
        // });
        // END - detect scroll up and down for nav
        ///////////////////////////////////////////////

        /////////////////////////////////////////////////////////////
        // START - keep menu transparent until scroll goes above 100px
        // COMMENTED OUT AS EARCU NEEDED IT IN VANILLA JS SEE BOTTOM OF FILE
        // $(window).on('load scroll', function(){
        //     if ($(window).scrollTop() > 86){
        //         $('html,body').addClass('nav-bg-color');
        //     } else {
        //         $('html,body').removeClass('nav-bg-color');
        //     }
        // });
        // END - keep menu transparent until scroll goes above 100px
        /////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////
        // START - supports multi level sub menus on bootstrap
        $('.dropdown-menu .dropdown-toggle').on('click', function(e) {
            if (!$(this).next().hasClass('show')) {
                $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
            }

            $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
                $('.dropdown-submenu .show').removeClass('show');
            });

            return false;
        });

        // multi level sub menus make class active and aria-expanded true
        $('.dropdown-menu .dropdown-toggle').on('click', function() {
			$(this).toggleClass('is-active');
			$(this).attr('aria-expanded', function(i, attr) {
				return attr == 'true' ? 'false' : 'true'
			});
		});
        
        // on mobile close 3rd level dropdown to get back to previous level menu
        document.querySelectorAll('.dropdown-close').forEach(function(button) {
            button.addEventListener('click', function(event) {
                // Stop the event from propagating to avoid unwanted behavior
                event.stopPropagation();
              
                // Find the closest dropdown menu
                var dropdownMenu = this.closest('.dropdown-menu');
              
                // Get the closest dropdown toggle button for this menu
                var dropdownToggle = dropdownMenu.previousElementSibling;
              
                    // If the previous sibling is not a button, move up to find the dropdown toggle button
                    if (!dropdownToggle || !dropdownToggle.classList.contains('dropdown-toggle')) {
                        dropdownToggle = dropdownMenu.closest('.dropdown').querySelector('.dropdown-toggle');
                    }
              
                // Get the dropdown instance and hide it
                var dropdown = bootstrap.Dropdown.getInstance(dropdownToggle);
                if (dropdown) {
                    dropdown.hide();
                }
            });
        });
        // END - supports multi level sub menus on bootstrap
        ///////////////////////////////////////////////

        /////////////////////////////////////////////////////
        // START - Desktop make header fix if dropdown menu is open.
        $('#mainMenuDesktop .dropdown-toggle').on('click', function() {
            if ($(this).attr('aria-expanded') === "true") {
                $('body').removeClass('desk-menu-open');
            } else {
                $('body').addClass('desk-menu-open');
            }
        });
        
        // Ensure body class is removed when the dropdown closes by any means
        // $('#mainMenuDesktop .dropdown').on('hidden.bs.dropdown', function () {
        //     $('body').removeClass('desk-menu-open');
        // });
        // END - Desktop make header fix if dropdown menu is open.
        /////////////////////////////////////////////////////

        ////////////////////////////////////////////////
        // START - slick slider example
        var slider = $('.slider-items');
        var slideStatus = $('.slider-page-info');

        if (slider.length > 0) {
            // set slides to same height
            slider.on('setPosition', function () {
                $(this).find('.slick-slide').height('auto');
                var slickTrack = $(this).find('.slick-track');
                var slickTrackHeight = $(slickTrack).height();
                $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
            });

            // add numbers for 1 of 5 or however many slider there are
            slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                var i = (currentSlide ? currentSlide : 0) + 1;
                slideStatus.text(i + '/' + slick.slideCount);
            });

            // initiate slider for home page
            slider.slick({
                autoplay: false,
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: $('#slider-prev'),
                nextArrow: $('#slider-next'),
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint:992,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                ]
            });
        }
        // END - slick slider example
        ///////////////////////////////////////////////

        ////////////////////////////////////////////////
        // START - slick slider with nav example
        var sliderWithNav = $('.slider-with-nav');
        var sliderNav = $('.slider-nav');

        if (sliderWithNav.length > 0) {
            sliderWithNav.slick({
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.slider-nav',
                responsive: [
                    {
                        breakpoint:767,
                        settings: {
                            fade: false,
                            autoplay: false
                        }
                    },
                ]
            });
            sliderNav.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.slider-with-nav',
                dots: false,
                focusOnSelect: true,
                vertical: true,
                responsive: [
                    {
                        breakpoint:767,
                        settings: {
                            // slidesToShow: 3,
                            // slidesToScroll: 1,
                            vertical: false
                        }
                    },
                ]
            });
        }
        // END - slick slider with nav example
        ///////////////////////////////////////////////

        // ////////////////////////////////////////////////
        // // START - turn tab row into slider
        // var tabSlider = $('.in-page-nav .tab-row');
        // // slick slider settings
        // var tabSliderSettings = {
        //     variableWidth: true,
        //     dots: false,
        //     infinite: false,
        //     touchThreshold: 100,
        //     prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span><span class="ico icon-arrow-left" aria-hidden="true"></span></button>',
        //     nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span><span class="ico icon-arrow-right" aria-hidden="true"></span></button>'
        // }

        // // check if tab row is on page
        // if (tabSlider.length > 0) {
        //     // work out resize function to reinit or destroy slider on load and window resize
        //     $(window).on('load resize', function() {
        //         // loop through each tab row component
        //         $('.tab-row').each(function() {
        //             tabSliderThis = $(this);
        //             // store tab row width
        //             var tabContainerWidth = $('.tab-row').width();
        //             var totalTabWidth = 0;
                    
        //             // loop through item just in its parent tab row
        //             $(this).find('.tab-row__item').each(function() {
        //                 // get outer width of each tab and add them all together
        //                 totalTabWidth += $(this).outerWidth(true); // include margin
        //             });
                    
        //             // init or destroy tab row slider depending on if total tab width is greater or less than tab row
        //             if (totalTabWidth < tabContainerWidth && $(this).hasClass('slick-initialized')) {
        //                 $(this).slick('unslick');
        //                 $(this).find('.tab-row__item').removeAttr("tabindex");
        //             } else if (totalTabWidth > tabContainerWidth) {
        //                 $(this).not('.slick-initialized').slick(tabSliderSettings);
        //             }
                    
        //             // work out when last slide is in view avoid lots of white space on right
        //             $(this).on('afterChange', function (e, slick) {
        //                 var lElRect = slick.$slides[slick.slideCount - 1].getBoundingClientRect();
        //                 var rOffset = lElRect.x + lElRect.width;
        //                 var wraRect = $(this).find('.slick-list', tabSlider).get(0).getBoundingClientRect();
            
        //                 if (rOffset < (wraRect.x + wraRect.width)) {
        //                     $(this).find('.slick-next').addClass('slick-disabled');
        //                     $(this).find('.slick-next').attr('aria-disabled', 'true');
        //                 } else {
        //                     $(this).find('.slick-next').removeClass('slick-disabled');
        //                     $(this).find('.slick-next').attr('aria-disabled', 'false');
        //                 }
        //             });

        //             /* Auto-select the dropdown menu item dependent on what page section you are viewing ( mobile ) */
        //             // window.addEventListener( 'scroll', function(ev) {
        //             //     for ( let i = 1; i < document.getElementsByClassName('dropdown-menu')[2].getElementsByClassName("dropdown-item").length + 1; i++ ) {
        //             //     if ( document.getElementById( 'block_' + [i] ) ) {
        //             //         let blockObj = document.getElementById( 'block_' + [i] )
        //             //         let distanceToTop = blockObj.getBoundingClientRect().top
        //             //         if ( ( document.getElementById( 'block_' + [i] ).getBoundingClientRect().top ) < 120 ) {
        //             //             let viewItemText = document.getElementsByClassName('dropdown-menu')[2].getElementsByClassName("dropdown-item")[i-1].text
        //             //             document.getElementsByClassName('dropdown-toggle')[2].getElementsByClassName('section-name-label')[0].innerHTML = viewItemText
        //             //         }
        //             //     }
                    
        //             //     } 
        //             // })
                    
        //             // /* Auto-select the dropdown menu item dependent on what page section you are viewing ( desktop ) */
        //             // if ( document.getElementById( 'block_1' ) ) {
        //             //     if ( document.getElementsByClassName( 'tab-row__item')[0] ) {
        //             //         document.getElementsByClassName( 'tab-row__item')[0].style.border ='1px solid white'
        //             //     }   
        //             // }
        //             // window.addEventListener( 'scroll', function( ev ) {
        //             //     let verticalDirection = ( this.oldScroll > this.scrollY ) ? 'up' : 'down' 
        //             //     for ( let i = 1; i < document.querySelectorAll( '.tab-row__item' ).length+1; i++ ) {
        //             //     if ( document.getElementById( 'block_' + [i] ) ) {
        //             //             let headerheight = document.querySelector('.in-page-nav').clientHeight
        //             //                             + document.querySelector('.header').clientHeight
        //             //             let heightFromTop = ( verticalDirection == 'down' ) 
        //             //                                 ? headerheight 
        //             //                                 : document.querySelector('#block_' + [i]).offsetHeight + headerheight
                                                    
                            
        //             //             if ( document.getElementById( 'block_' + [i] ) && document.getElementById( 'block_' + [i] ).getBoundingClientRect().top < heightFromTop - 120 ) {
        //             //                 if ( i !== 1 && document.getElementsByClassName( 'tab-row__item')[i-2] ) {
        //             //                     document.getElementsByClassName( 'tab-row__item')[i-2].style.border = 'unset';
        //             //                 }
        //             //                 if ( document.getElementsByClassName( 'tab-row__item')[i-1] ) {
        //             //                     document.getElementsByClassName( 'tab-row__item')[i-1].style.border ='1px solid white'

        //             //                     let index = document.getElementsByClassName( 'tab-row__item')[i-1].getAttribute('data-slick-index')
        //             //                     console.log(document.getElementsByClassName( 'tab-row__item')[i-1])
        //             //                     console.log(tabSliderThis)
        //             //                     $(tabSliderThis).slick('slickGoTo', index)
                                        
        //             //                 }
        //             //             } 
        //             //             else {
        //             //                 if ( document.getElementsByClassName( 'tab-row__item')[i-1] ) {
        //             //                     document.getElementsByClassName( 'tab-row__item')[i-1].style.border = 'unset';
        //             //                 }            
        //             //             }
                    
        //             //             if ( document.getElementById( 'block_1' ) && document.getElementById( 'block_1' ).getBoundingClientRect().top < 600 ) {
        //             //                 if ( document.getElementsByClassName( 'tab-row__item')[0] ) {
        //             //                     document.getElementsByClassName( 'tab-row__item')[0].style.border ='1px solid white'

        //             //                     let index = document.getElementsByClassName( 'tab-row__item')[i-1].getAttribute('data-slick-index')
        //             //                     console.log(document.getElementsByClassName( 'tab-row__item')[i-1])
        //             //                     console.log(tabSliderThis)
        //             //                     $(tabSliderThis).slick('slickGoTo', index)
        //             //                 }   
        //             //             }

        //             //             if ( document.getElementById( 'block_2' ) && document.getElementById( 'block_2' ).getBoundingClientRect().top < heightFromTop - 120 ) {
        //             //                 if ( document.getElementsByClassName( 'tab-row__item')[0] ) {
        //             //                     document.getElementsByClassName( 'tab-row__item')[0].style.border ='unset'
        //             //                 }   
        //             //             }

        //             //             // get data attribute for active slide
        //             //     }
        //             //     } 
        //             //     this.oldScroll = this.scrollY;
        //             // });
        //         });
        //     });
        // }

        // // Anchor Nav - set dropdown label to selected anchor name on change.
        // $('.in-page-nav .dropdown-menu .dropdown-item').on('click', function() {
        //     $('.dropdown-toggle .section-name-label').text(this.text);
        // });
        
        $(document).ready(function () {
            // Check if in-page-nav exists before running any code
            if (document.querySelector('.in-page-nav')) {
                let hasUserInteracted = false;
                let currentSlideIndex = 0;
                let isSliding = false; // Flag to prevent overlapping slide animations
                let pendingSlideTarget = null; // Store pending target if currently sliding
                let slideDebounceTimer = null; // Debounce timer for slide movements
                let isClickScrolling = false; // Flag to pause scroll detection during smooth scroll
                let keyboardHandlersAttached = false; // Prevent duplicate keyboard handlers
                const inPageNav = $('.in-page-nav');

                const tabSliderSettings = {
                    variableWidth: true,
                    dots: false,
                    infinite: false,
                    touchThreshold: 100,
                    initialSlide: 0,
                    accessibility: true,
                    prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span><span class="ico icon-arrow-left" aria-hidden="true"></span></button>',
                    nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span><span class="ico icon-arrow-right" aria-hidden="true"></span></button>'
                };

                // Attach keyboard navigation handlers only once
                function handleKeyboardNavigation() {
                    if (keyboardHandlersAttached) return;
                    keyboardHandlersAttached = true;
                    
                    inPageNav.on('keydown', '.tab-row__item', function(e) {
                        const $currentLink = $(this);
                        const $slider = $currentLink.closest('.slick-slider');
                        if (!$slider.length) return;
                        
                        const $allLinks = $slider.find('.tab-row__item');
                        const currentIndex = $allLinks.index($currentLink);

                        if (e.which === 9) { // Tab key
                            if (!e.shiftKey && currentIndex < $allLinks.length - 1) {
                                e.preventDefault();
                                const nextIndex = $($allLinks[currentIndex + 1]).data('slick-index');
                                if (typeof nextIndex !== 'undefined') {
                                    $slider.slick('slickGoTo', nextIndex);
                                }
                                $($allLinks[currentIndex + 1]).focus();
                            } else if (e.shiftKey && currentIndex > 0) {
                                e.preventDefault();
                                const prevIndex = $($allLinks[currentIndex - 1]).data('slick-index');
                                if (typeof prevIndex !== 'undefined') {
                                    $slider.slick('slickGoTo', prevIndex);
                                }
                                $($allLinks[currentIndex - 1]).focus();
                            }
                        }
                    });
                }

                function initOrDestroyTabSlider() {
                    inPageNav.find('.tab-row').each(function () {
                        const tabSliderThis = $(this);
                        const tabContainerWidth = tabSliderThis.width();
                        let totalTabWidth = 0;
                        
                        // Get active slide index before potentially destroying slider
                        // Only use active-item class (not slick-active, which Slick manages internally)
                        let activeSlideIndex = 0;
                        const activeItem = inPageNav.find('.tab-row__item.active-item').first();
                        if (activeItem.length) {
                            activeSlideIndex = activeItem.data('slick-index') || 0;
                        }

                        tabSliderThis.find('.tab-row__item').each(function () {
                            totalTabWidth += $(this).outerWidth(true);
                        });

                        if (totalTabWidth < tabContainerWidth && tabSliderThis.hasClass('slick-initialized')) {
                            // Destroy slider - items fit without needing slider
                            tabSliderThis.slick('unslick');
                        } else if (totalTabWidth > tabContainerWidth) {
                            // Need slider - items overflow
                            if (tabSliderThis.hasClass('slick-initialized')) {
                                tabSliderThis.slick('unslick');
                            }
                            
                            tabSliderThis.slick(tabSliderSettings)
                                .on('afterChange', function(event, slick, currentSlide) {
                                    // Sync our tracking variable with slick's actual position
                                    currentSlideIndex = currentSlide;
                                    isSliding = false;
                                    
                                    // If there's a pending target, go to it now
                                    if (pendingSlideTarget !== null && pendingSlideTarget !== currentSlide) {
                                        const target = pendingSlideTarget;
                                        pendingSlideTarget = null;
                                        moveToNextSlide(target);
                                    }
                                })
                                .on('beforeChange', function() {
                                    isSliding = true;
                                });

                            // Restore active slide position
                            if (activeSlideIndex > 0) {
                                tabSliderThis.slick('slickGoTo', activeSlideIndex, true);
                                currentSlideIndex = activeSlideIndex;
                            }
                            
                            // Initialize keyboard navigation once
                            handleKeyboardNavigation();
                        }
                    });
                }

                // Throttle function for resize events
                function throttle(func, limit) {
                    let inThrottle;
                    return function() {
                        const args = arguments;
                        const context = this;
                        if (!inThrottle) {
                            func.apply(context, args);
                            inThrottle = true;
                            setTimeout(() => inThrottle = false, limit);
                        }
                    }
                }

                function updateDropdownLabel(text) {
                    const label = inPageNav.find('.dropdown-toggle .section-name-label');
                    if (label.length && text) {
                        label.text(text.trim());
                    }
                }

                function moveToNextSlide(targetIndex) {
                    const slickSlider = inPageNav.find('.tab-row--in-page-nav');
                    if (!slickSlider.length || !slickSlider.hasClass('slick-initialized')) return;
                    
                    // Validate target index
                    if (typeof targetIndex !== 'number' || isNaN(targetIndex)) return;
                    
                    // If target is same as current, do nothing
                    if (targetIndex === currentSlideIndex) return;
                    
                    // If currently sliding, store the target for later
                    if (isSliding) {
                        pendingSlideTarget = targetIndex;
                        return;
                    }

                    // Clear any pending debounce
                    if (slideDebounceTimer) {
                        clearTimeout(slideDebounceTimer);
                    }

                    // Debounce the slide movement to prevent rapid consecutive calls
                    slideDebounceTimer = setTimeout(function() {
                        // Verify slider still exists and is initialized
                        if (!slickSlider.hasClass('slick-initialized')) return;
                        
                        // Get slick's actual current slide to ensure we're in sync
                        const slickCurrentSlide = slickSlider.slick('slickCurrentSlide');
                        currentSlideIndex = slickCurrentSlide;
                        
                        // If target is still different, move one step towards it
                        if (targetIndex !== currentSlideIndex) {
                            const direction = targetIndex > currentSlideIndex ? 1 : -1;
                            const nextSlide = currentSlideIndex + direction;
                            
                            isSliding = true;
                            pendingSlideTarget = targetIndex !== nextSlide ? targetIndex : null;
                            slickSlider.slick('slickGoTo', nextSlide, false);
                        }
                    }, 50);
                }

                function observeSections() {
                    const navLinks = inPageNav.find('.tab-row__item');
                    if (!navLinks.length) return { checkCurrentlyVisibleSection: function() {} };
                    
                    const validSectionIds = navLinks.map(function() {
                        const href = $(this).attr('href');
                        return href ? href.replace('#', '') : null;
                    }).get().filter(Boolean);
                    
                    let observerDebounceTimer = null;
                    let lastActiveSection = null;
                    
                    // Function to update the active nav item
                    // Note: We don't use slick-active class - Slick manages that internally for visible slides
                    // We only use active-item and anchor-active for tracking the currently in-view section
                    function updateActiveNavItem(sectionId, forceSliderUpdate) {
                        if (sectionId === lastActiveSection && !forceSliderUpdate) return;
                        if (isClickScrolling) return; // Don't update during smooth scroll from click
                        
                        lastActiveSection = sectionId;
                        
                        // Debounce the update to prevent rapid changes
                        if (observerDebounceTimer) {
                            clearTimeout(observerDebounceTimer);
                        }
                        
                        observerDebounceTimer = setTimeout(function() {
                            const correspondingLink = inPageNav.find(`.tab-row__item[href="#${sectionId}"]`);
                            const correspondingDropdownItem = inPageNav.find(`.dropdown-item[href="#${sectionId}"]`);
                            
                            if (correspondingLink.length) {
                                // Update tab row items - only use active-item and anchor-active
                                // Don't touch slick-active as Slick manages that for visible slides
                                inPageNav.find('.tab-row__item').removeClass('active-item anchor-active');
                                correspondingLink.addClass('active-item anchor-active');
                                
                                // Update dropdown items
                                inPageNav.find('.dropdown-item').removeClass('active-item');
                                if (correspondingDropdownItem.length) {
                                    correspondingDropdownItem.addClass('active-item');
                                }
                                
                                updateDropdownLabel(correspondingLink.text());
                                
                                const targetIndex = correspondingLink.data('slick-index');
                                if (typeof targetIndex === 'number') {
                                    moveToNextSlide(targetIndex);
                                }
                            }
                        }, 100);
                    }
                    
                    // Function to manually check which section is currently visible
                    function checkCurrentlyVisibleSection() {
                        if (isClickScrolling) return; // Skip during smooth scroll
                        
                        let bestMatch = null;
                        let bestVisibility = 0;
                        
                        validSectionIds.forEach(id => {
                            const section = document.getElementById(id);
                            if (section) {
                                const rect = section.getBoundingClientRect();
                                const windowHeight = window.innerHeight;
                                
                                // Calculate visible portion within the middle 50% of viewport
                                const viewportTop = windowHeight * 0.25;
                                const viewportBottom = windowHeight * 0.75;
                                
                                const visibleTop = Math.max(rect.top, viewportTop);
                                const visibleBottom = Math.min(rect.bottom, viewportBottom);
                                const visibleHeight = Math.max(0, visibleBottom - visibleTop);
                                
                                if (visibleHeight > bestVisibility) {
                                    bestVisibility = visibleHeight;
                                    bestMatch = id;
                                }
                            }
                        });
                        
                        if (bestMatch) {
                            updateActiveNavItem(bestMatch, false);
                        }
                    }

                    const observer = new IntersectionObserver((entries) => {
                        if (!hasUserInteracted || isClickScrolling) return;

                        // Find the most visible section
                        let mostVisibleEntry = null;
                        let highestRatio = 0;

                        entries.forEach(entry => {
                            if (entry.isIntersecting && entry.intersectionRatio > highestRatio) {
                                highestRatio = entry.intersectionRatio;
                                mostVisibleEntry = entry;
                            }
                        });

                        if (mostVisibleEntry && mostVisibleEntry.intersectionRatio >= 0.5) {
                            updateActiveNavItem(mostVisibleEntry.target.id, false);
                        }
                    }, {
                        threshold: [0.5],
                        rootMargin: '-25% 0px -25% 0px'
                    });

                    validSectionIds.forEach(id => {
                        const section = document.getElementById(id);
                        if (section) {
                            observer.observe(section);
                        }
                    });
                    
                    // Expose the check function for use when user interaction starts
                    return { checkCurrentlyVisibleSection };
                }

                let sectionObserver = null;
                
                function setUserInteracted() {
                    hasUserInteracted = true;
                    
                    // Immediately check which section is visible when user first interacts
                    if (sectionObserver) {
                        sectionObserver.checkCurrentlyVisibleSection();
                    }
                    
                    ['scroll', 'click', 'touchstart'].forEach(event => {
                        document.removeEventListener(event, setUserInteracted);
                    });
                }

                ['scroll', 'click', 'touchstart'].forEach(event => {
                    document.addEventListener(event, setUserInteracted);
                });

                // Initialize functionality with throttled resize
                $(window).on('load', initOrDestroyTabSlider);
                $(window).on('resize', throttle(function() {
                    initOrDestroyTabSlider();
                }, 250));
                
                // Handle nav item clicks - pause scroll detection during smooth scroll
                inPageNav.on('click', '.tab-row__item, .dropdown-item', function(e) {
                    const href = $(this).attr('href');
                    if (!href || !href.startsWith('#')) return;
                    
                    const targetId = href.replace('#', '');
                    const targetSection = document.getElementById(targetId);
                    
                    if (targetSection) {
                        // Update active state immediately on click
                        // Don't touch slick-active - only use active-item and anchor-active
                        inPageNav.find('.tab-row__item').removeClass('active-item anchor-active');
                        inPageNav.find(`.tab-row__item[href="${href}"]`).addClass('active-item anchor-active');
                        
                        inPageNav.find('.dropdown-item').removeClass('active-item');
                        $(this).addClass('active-item');
                        
                        updateDropdownLabel($(this).text());
                        
                        // Move slider to clicked item
                        const targetIndex = inPageNav.find(`.tab-row__item[href="${href}"]`).data('slick-index');
                        if (typeof targetIndex === 'number') {
                            moveToNextSlide(targetIndex);
                        }
                        
                        // Pause scroll detection during smooth scroll
                        isClickScrolling = true;
                        setTimeout(function() {
                            isClickScrolling = false;
                        }, 1000); // Resume after 1 second
                    }
                });
                
                // Handle dropdown clicks for label update
                inPageNav.find('.dropdown-menu .dropdown-item').on('click', function() {
                    updateDropdownLabel($(this).text());
                });

                // Start observing sections
                sectionObserver = observeSections();
                
                // Add throttled scroll listener as fallback for reliable section detection
                $(window).on('scroll', throttle(function() {
                    if (hasUserInteracted && sectionObserver && !isClickScrolling) {
                        sectionObserver.checkCurrentlyVisibleSection();
                    }
                }, 150));
                
                // Set initial active state for first item if none is active
                // Don't use slick-active - only use active-item and anchor-active
                if (!inPageNav.find('.tab-row__item.active-item').length) {
                    const firstLink = inPageNav.find('.tab-row__item:first');
                    if (firstLink.length) {
                        firstLink.addClass('active-item anchor-active');
                        updateDropdownLabel(firstLink.text());
                    }
                }
            }
        });
    });
});

"use strict";

////////////////////////////////////////////////
// START -  mobile nav toggle JS
var navbarToggler = document.querySelector('.navbar-toggler');
var navbarBg = document.querySelector( '.navbar-bg' );
var navBar = document.querySelector( '.navbar' );
var ariaExpanded = navbarToggler.getAttribute( 'aria-expanded' ); 

navbarToggler.addEventListener( 'click' , function() {

    navBar.classList.toggle( 'is-active' );

    if (ariaExpanded == 'true' ) {
        ariaExpanded = 'false'
    } else {
        ariaExpanded = 'true'
    }
    navbarToggler.setAttribute( 'aria-expanded' , ariaExpanded);
});
// END - mobile nav toggle JS
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - remove load class from body
window.addEventListener('load', function() {
    document.body.classList.remove('page-loading');
});
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - only show focus ring on tab not click
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);
// END - only show focus ring on tab not click
///////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////
// START - reset tabbed menu when dropdown is closed
document.addEventListener('DOMContentLoaded', function() {
    // Check if .nav-desk .dropdown exists on the page
    const navDeskDropdowns = document.querySelectorAll('.nav-desk .dropdown');

    if (navDeskDropdowns.length > 0) {
        // Select all dropdown elements inside .nav-desk
        navDeskDropdowns.forEach(dropdown => {
            // Add event listener for when the dropdown is hidden
            dropdown.addEventListener('hidden.bs.dropdown', function() {
                // Find the .mega-menu-tabs inside the dropdown
                const megaMenuTabs = dropdown.querySelector('.mega-menu-tabs');

                if (megaMenuTabs) {
                    // Select all .tabbed-content-div and anchor elements within the .mega-menu-tabs
                    const tabbedContentDivs = megaMenuTabs.querySelectorAll('.tabbed-content-div');
                    const tabLinks = megaMenuTabs.querySelectorAll('.tabbed-content-nav__links a');

                    if (tabbedContentDivs.length > 0) {
                        // Remove .show and .active from all .tabbed-content-div elements
                        tabbedContentDivs.forEach(div => {
                            div.classList.remove('show', 'active');
                        });

                        // Add .show and .active to the first .tabbed-content-div
                        tabbedContentDivs[0].classList.add('show', 'active');

                        // Remove .active and aria-selected="true" from all tab links
                        tabLinks.forEach(link => {
                            link.classList.remove('active');
                            link.removeAttribute('aria-selected');
                        });
                    }
                }
            });

            // Add event listener for when the dropdown is shown
            dropdown.addEventListener('shown.bs.dropdown', function() {
                // Find the .mega-menu-tabs inside the dropdown
                const megaMenuTabs = dropdown.querySelector('.mega-menu-tabs');

                if (megaMenuTabs) {
                    // Add click event listener to each tab link
                    const tabLinks = megaMenuTabs.querySelectorAll('[data-bs-toggle="pill"]');

                    tabLinks.forEach(link => {
                        link.addEventListener('click', function(e) {
                            // Prevent default action
                            e.preventDefault();

                            // Get the target pane ID from the clicked link
                            const targetPaneID = link.getAttribute('href');

                            // Select all .tabbed-content-div elements
                            const tabbedContentDivs = megaMenuTabs.querySelectorAll('.tabbed-content-div');

                            // Remove .show and .active from all .tabbed-content-div elements
                            tabbedContentDivs.forEach(div => {
                                div.classList.remove('show', 'active');
                            });

                            // Find the target pane and add the .show and .active classes
                            const targetPane = megaMenuTabs.querySelector(targetPaneID);
                            if (targetPane) {
                                targetPane.classList.add('show', 'active');
                            }

                            // Remove .active and aria-selected="true" from all tab links
                            tabLinks.forEach(link => {
                                link.classList.remove('active');
                                link.removeAttribute('aria-selected');
                            });

                            // Add .active and aria-selected="true" to the clicked tab link
                            link.classList.add('active');
                            link.setAttribute('aria-selected', 'true');
                        });
                    });
                }
            });
        });
    }
});
/////////////////////////////////////////////////////////////////////////
// END - reset tabbed menu when dropdown is closed

////////////////////////////////////////////////////////
// START - hide nav on scroll down and show on scroll up
// document.addEventListener('DOMContentLoaded', function () {
//     let lastScrollTop = 0;
//     const delta = 5;
//     const header = document.querySelector('.header');
//     const body = document.body;
//     const animatedRead = document.querySelector('.animated-read'); // Select .animated-read if it exists

//     window.addEventListener('scroll', function () {
//         const nowScrollTop = window.scrollY || document.documentElement.scrollTop;

//         // Check if the user scrolled more than the delta
//         if (Math.abs(lastScrollTop - nowScrollTop) > delta) {
//             if (nowScrollTop > lastScrollTop) {
//                 // Scrolling down
//                 header.classList.add('header-hide');
//                 header.classList.remove('header-show');
//                 body.classList.add('header-hide');
//                 body.classList.remove('header-show');
//             } else {
//                 // Scrolling up
//                 header.classList.remove('header-hide');
//                 header.classList.add('header-show');
//                 body.classList.remove('header-hide');
//                 body.classList.add('header-show');
//             }

//             // Add the .interacted class to .animated-read if it exists
//             if (animatedRead) {
//                 animatedRead.classList.add('interacted');
//             }

//             // Update the last scroll position
//             lastScrollTop = nowScrollTop;
//         }
//     });
// });

// END - hide nav on scroll down and show on scroll up
//////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
// START - keep menu transparent until scroll goes above 86px
// window.addEventListener('load', checkScroll);
// window.addEventListener('scroll', checkScroll);

// function checkScroll() {
//     const scrollTop = window.scrollY || document.documentElement.scrollTop;
//     const body = document.body;
//     const html = document.documentElement;

//     if (scrollTop > 86) {
//         html.classList.add('nav-bg-color');
//         body.classList.add('nav-bg-color');
//     } else {
//         html.classList.remove('nav-bg-color');
//         body.classList.remove('nav-bg-color');
//     }
// }
// END - keep menu transparent until scroll goes above 86px
/////////////////////////////////////////////////////////////
